import { render } from "./TourLocked.vue?vue&type=template&id=c4c406c4"
import script from "./TourLocked.vue?vue&type=script&lang=ts"
export * from "./TourLocked.vue?vue&type=script&lang=ts"
script.render = render

export default script